import type { SharedReadbackEntry } from "./shared-readback-entry";

export const sharedReadbackCache = new Map<number, SharedReadbackEntry>();
